var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ckeditor',{attrs:{"editor":_vm.editor,"config":_vm.editorConfig,"disabled":_vm.disabled},model:{value:(_vm.editorData),callback:function ($$v) {_vm.editorData=$$v},expression:"editorData"}}),_c('textarea',{staticStyle:{"display":"none"},attrs:{"name":_vm.name}},[_vm._v(_vm._s(_vm.nativeValue))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }